import React from 'react'
import styles from './footer.module.css'
import FooterNav from './footer-nav'
import SocialNetworkNav from './social-network-nav'

const Footer = () => (
  <footer className={styles.footer}>
    <FooterNav />
    <SocialNetworkNav />
    <p className={styles.contact}>Get in touch:</p>
    <p className={styles.email}><a href='mailto:hello@switchpal.co.uk'>hello@switchpal.co.uk</a></p>
    <p className={styles.copyright}>© Switch Pal Limited {new Date().getFullYear()}</p>
    <p className={styles.companyNumber}>Switch Pal Limited is registered in England & Wales: 12545529</p>
  </footer>
)

export default Footer